import React from 'react';
import { PropTypes } from 'prop-types';
import { useRouteMatch } from 'react-router-dom';
import styled from 'styled-components';
import { useScreenMinLg } from '@hooks/useResponsive';

const List = styled.ul`
    list-style: none;
    margin-left: 48px;
`;

const SidebarSubnav = props => {
    const { to, children } = props;
    const isDesktop = useScreenMinLg();
    const match = useRouteMatch({
        path: to,
        exact: false,
    });

    if (!match || !isDesktop) return null;

    return <List>{children}</List>;
};

SidebarSubnav.propTypes = {
    to: PropTypes.string,
    children: PropTypes.oneOfType([PropTypes.element, PropTypes.node, PropTypes.string]),
};

export default SidebarSubnav;
